(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/store.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/store.js');
"use strict";

(function (svs) {
  'use strict';

  svs.grassroots_partner.createStore = () => {
    svs.grassroots_partner.store = svs.utils.reactHelpUtils.createStore({
      grassroot: svs.grassroots_partner.reducers.GeneralGrassrootReducer
    }, {
      grassroot: {
        checked: false,
        userName: '',
        errorMessage: ''
      }
    });
  };
})(svs);

 })(window);